/**
 * Common language list for the first-language autocomplete field.
 * Ordered roughly by global speaker count, then alphabetically.
 */
export const LANGUAGES: string[] = [
  "English",
  "Mandarin Chinese",
  "Hindi",
  "Spanish",
  "French",
  "Arabic",
  "Bengali",
  "Russian",
  "Portuguese",
  "Urdu",
  "Indonesian",
  "German",
  "Japanese",
  "Swahili",
  "Marathi",
  "Telugu",
  "Turkish",
  "Tamil",
  "Vietnamese",
  "Korean",
  "Italian",
  "Hausa",
  "Gujarati",
  "Punjabi",
  "Polish",
  "Ukrainian",
  "Romanian",
  "Dutch",
  "Greek",
  "Hungarian",
  "Czech",
  "Swedish",
  "Finnish",
  "Norwegian",
  "Danish",
  "Hebrew",
  "Persian (Farsi)",
  "Pashto",
  "Somali",
  "Amharic",
  "Yoruba",
  "Igbo",
  "Zulu",
  "Xhosa",
  "Malay",
  "Thai",
  "Burmese",
  "Sinhala",
  "Nepali",
  "Kannada",
  "Malayalam",
  "Odia",
  "Serbian",
  "Croatian",
  "Slovak",
  "Bulgarian",
  "Catalan",
  "Tagalog",
  "Other",
];
